import { modifier } from '@utils/swr-utils';
import { MODELS_PATH } from './paths';

export default function uploadModel(payload: object) {
  const url = MODELS_PATH + '?dryRun=false';
  return modifier(url, payload);
}
